import { slavicPluralize } from "../js/util/SlavicPluralize";
window.locale = "uk";
window.strings = {
    toLang: "В ",
    convertTextToLang: "Конвертувати виділений текст в ",
    showKeyboard: "показати клавіатуру",
    hideKeyboard: "сховати клавіатуру",
    showAbout: "показати про нас",
    hideAbout: "сховати про нас",
    min: "хв",
    sec: "сек",
    readingTime: "час читання",
    speakingTime: "час говоріння",
    languages: {
        ru: "Російська",
        uk: "Українська",
        be: "Білоруська",
        bg: "Болгарська",
        de: "Німецька",
        fr: "Французька",
        es: "Іспанська",
        pt: "Португальська",
        it: "Італійська",
        tr: "Турецька",
        "da/no": "Дано-Норвежська",
        sv: "Шведська",
        fi: "Фінська",
        cs: "Чешська",
        nl: "Нідерландська",
        pl: "Польська",
        hu: "Угорська",
        ro: "Румунська",
        mi: "Маорі",
        fo: "Фарерська",
        ic: "Ісландська",
        el: "Грецька",
        ka: "Грузинська"
    },
    feedbackThanks: "Спасибі за ваш відгук",
    counters: {
        getCharacterPlural(count) {
            return slavicPluralize(count, "символ", "символи", "символів");
        },
        getWordPlural(count) {
            return slavicPluralize(count, "слово", "слова", "слів");
        }
    }
};
